<template>
    <div>
        <div class="btn-group" role="group">
            <button type="button"
                v-on:click="resetLocation"
                class="btn btn-secondary btn-icon btn-rounded"
                style="margin: 1rem 0rem; position: absolute; top: 5px; left: 10px; z-index: 1;">
                <i class="material-icons">gps_fixed</i>
                Reset</button>
        </div>
        <gmap-map
            v-on:zoom_changed="onZoomChanged"
            :center="center"
            :zoom="currentZoom || marker.zoom"
            :options="mapOptions"
            style="width:100%;  height: 400px;">
            <gmap-marker
                v-on:dragend="onDragEnd"
                v-on:click="center=marker.position"
                :position="marker.position"
                :clickable="true"
                :draggable="!readonly"
                ></gmap-marker>
        </gmap-map>
    </div>
</template>

<script>
import _ from 'lodash';
import Vue from 'vue';
import GMaps from 'gmaps';

const defaultMarker = {
    zoom: 10,
    position: { lat: -37.1986694, lng: 174.9056512 },
};

export default {
    name: "MapMarkerComponent",

    data() {
        const marker = this.getLocationMarker(this.value);
        return {
            marker,
            center: marker.position,
            currentZoom: marker.zoom || 10,
            mapOptions: {
                disableDefaultUI: true,
                mapTypeControl: false,
                scaleControl: true,
                zoomControl: true,
                fullscreenControl: true,
                zoomControlOptions: {
                    // style: google.maps.ZoomControlStyle.LARGE
                },
            }
        };
    },

    props: ['value', 'data', 'config'],

    mounted() {
        if (!this.value) this.geolocate();
    },

    watch: {
        value(newVal) {
            const newMarker = this.getLocationMarker(newVal);
            this.marker = newMarker;
            this.center = newMarker.position;
            this.currentZoom = newMarker.zoom;
        },
    },

    computed: {
        readonly() {
            return _.get(this.config, 'readonly', false);
        }
    },

    methods: {
        // receives a place object via the autocomplete component
        geolocate() {
            navigator.geolocation.getCurrentPosition(position => {
                const location = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };

                this.center = location;
                this.marker = { position: location };
                this.$emit('input', this.getLocationValue(location, this.currentZoom));
            });
        },

        onDragEnd(e) {
            this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            this.$emit('input', this.getLocationValue(this.marker.position, this.currentZoom || 10));
        },

        onZoomChanged(zoom) {
            this.currentZoom = zoom;
            this.$emit('input', this.getLocationValue(this.marker.position, zoom));
        },

        getLocationMarker(value) {
            if (_.isNil(value)) {
                return defaultMarker;
            } else if (_.isString(value)) {
                const [lat, lng, zoom] = value.split(/[\,\;\|]/);
                return (lat && lng) ?
                    { position: { lat: parseFloat(lat), lng: parseFloat(lng) }, zoom: zoom ? parseInt(zoom) : 10 } : defaultMarker;
            } else if (_.isObject(value)) {
                return value;
            } else {
                return defaultMarker;
            }
        },

        getLocationValue(location, zoom = 10) {
            if (_.isNil(location)) {
                return '';
            } else if (_.isString(location)) {
                return `${location},${zoom}`;
            } else if (_.isObject(location)) {
                return `${location.lat},${location.lng},${zoom}`;
            } else {
                return '';
            }
        },

        resetLocation() {
            if (this.config.addressField) {
                let address = '';
                _.castArray(this.config.addressField).forEach(
                    (field) => address += this.data[field] ? `, ${this.data[field]}` : '');

                return GMaps.geocode({
                    address,
                    callback: (positions) => {
                        let location = _.first(positions).geometry.location;

                        if (location) {
                            location = {
                                lat: location.lat(),
                                lng: location.lng(),
                            }
                            this.marker.position = location;
                            this.center = location;
                            this.$emit('input', this.getLocationValue(location, this.currentZoom));
                        }
                    }
                })
            }

            return this.geolocate();
        },
    }
};
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/form-elements/MapMarkerComponent.vue